import { ILevelLogClass, LevelLogProps } from '../types';
import { systemLogMethod } from '../utils/systemLogMethod';
import { systemDictionary } from '../Dictionaries/SystemDictionary';
import * as T from '../types';
import { SystemLoggerType } from '../Dictionaries/types/types';

/**
 * SystemLogger produces log methods that ALWAYS emit, regardless of any
 * configuration. They bypass enable, allowedTypes, setLocalOptions() and
 * every manifest or localStorage override.
 */
class SystemLogger implements ILevelLogClass {
  private _systemLogs: T.FunctionWithLogMethods =
    {} as T.FunctionWithLogMethods;

  constructor(loggerProps: LevelLogProps) {
    // default system log falls back to s1
    const _defaultLog = (...value) => this._systemLogs['s1']?.(...value);

    systemDictionary.forEach((logMethods) => {
      const _method = systemLogMethod({
        ...logMethods,
        loggerProps,
        serviceName: loggerProps.serviceName,
        preffixLog: loggerProps.preffixLog,
        appName: loggerProps.appName,
        applicationContext: loggerProps.applicationContext,
        envStack: loggerProps.envStack,
        authenticationProvider: loggerProps.authenticationProvider
      });
      _defaultLog[logMethods.id] = _method;
    });

    this._systemLogs = _defaultLog as unknown as T.FunctionWithLogMethods;
  }

  getLogs(): SystemLoggerType {
    return this._systemLogs as SystemLoggerType;
  }
}

export default SystemLogger;
